import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Code2, Github, Linkedin, Mail, FileText, Twitter, ArrowRight, Phone, MapPin } from 'lucide-react';
import { profileData } from '../../data/mock';
import { useToast } from '../../hooks/use-toast';
import { subscribeUser } from '@/hooks/useSubscribe';
import { handleSubscribe } from '@/utils/subscribeHandler';
import SubscribeNewsletter from '../ui/SubscribeNewsletter';

const Footer = () => {
  // const [email, setEmail] = useState('');
  // const { toast } = useToast();

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   handleSubscribe(email, setEmail, toast);
  // };

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Experience', path: '/experience' },
    { name: 'Certifications', path: '/certifications' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const socialLinks = [
    { name: 'GitHub', icon: Github, url: profileData.social.github },
    { name: 'LinkedIn', icon: Linkedin, url: profileData.social.linkedin },
    { name: 'Medium', icon: FileText, url: profileData.social.medium },
    { name: 'Twitter', icon: Twitter, url: profileData.social.twitter },
  ];

  return (
    <footer  id="main-footer" className="bg-muted/50 border-t">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-purple-600 to-purple-700 text-white">
                <Code2 className="h-5 w-5" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-purple-600 to-black bg-clip-text text-transparent">
                {profileData.name}
              </span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs">
              Full Stack Developer & Data Engineer passionate about building scalable solutions and sharing knowledge.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <Button
                  key={social.name}
                  variant="ghost"
                  size="icon"
                  asChild
                  className="h-8 w-8 hover:text-purple-600 transition-colors"
                >
                  <a href={social.url} target="_blank" rel="noopener noreferrer">
                    <social.icon className="h-4 w-4" />
                  </a>
                </Button>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-purple-600 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-sm font-semibold">Contact</h3>
            <div className="space-y-2 text-sm text-muted-foreground">
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <a href={`mailto:${profileData.email}`} className="hover:text-purple-600 transition-colors">
                  {profileData.email}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4" />
                <p className="hover:text-purple-600 transition-colors">
                  {profileData.location}
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4" />
                <p className="hover:text-purple-600 transition-colors">
                  {profileData.phone}
                </p>
              </div>
            </div>
          </div>

          {/* Newsletter Subscription */}
          {/* <div className="space-y-4">
            <h3 className="text-sm font-semibold">Stay Updated</h3>
            <p className="text-sm text-muted-foreground">
              Subscribe to get notified about new blog posts and projects.
            </p>
            <form onSubmit={onSubmit} className="space-y-2">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="text-sm"
                required
              />
              <Button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 text-white">
                Subscribe
                <ArrowRight className="ml-2 h-3 w-3" />
              </Button>
            </form>
          </div> */}
          <SubscribeNewsletter />
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <div className="text-center text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} {profileData.name}. All rights reserved.</p>
            <p className="mt-1">Developed by Syed Bakhtawar Fahim</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;